import Details from './Details';
import Schedule from './Schedule';
import Price from './Price';
import StartDate from './StartDate';
import Location from './Location';
import Careplan from './Careplan';
import Requirements from './Requirements';
import Consideration from './Consideration';
import Review from './Review';
import {translate} from 'views/module';

const STEPS = [
  {
    title: translate('career.create.Steps.Details'),
    component: Details,
  },
  {
    title: translate('career.create.Steps.Schedule'),
    component: Schedule,
  },
  {
    title: translate('career.create.Steps.Price'),
    component: Price,
  },
  {
    title: translate('career.create.Steps.StartDate'),
    component: StartDate,
  },
  {
    title: translate('career.create.Steps.Location'),
    component: Location,
  },
  {
    title: translate('career.create.Steps.Requirements'),
    component: Requirements,
  },
  {
    title: translate('career.create.Steps.CarePlan'),
    component: Careplan,
  },
  {
    title: translate('career.create.Steps.Considerations'),
    component: Consideration,
  },
  {
    title: translate('career.create.Steps.Review'),
    component: Review,
  },
];

export default STEPS;
